import * as Lucide from "lucide-react";

// Renders a lucide icon by string name from data files.
export const Icon = ({ name, ...props }) => {
  const Cmp = Lucide[name] || Lucide.Square;
  return <Cmp {...props} />;
};
